export const environment = {
    production: false,
    companyName: 'IBSC',
    companyCode: 1,
    whatsappNumber: '1712204095',
    // apiUrl: 'http://localhost:1001/p',
    // ImageApi: 'http://localhost:1001/uploads/',
    webUrl: 'https://mediray.supersoftbd.com',
    apiUrl: 'https://api.mediray.supersoftbd.com/p',
    ImageApi: 'https://api.mediray.supersoftbd.com/uploads/',
    emptyImg: 'https://www.mykite.in/kb/NoImageFound.jpg.png',
    keywords: ['medical equipment', 'healthcare products', 'x-ray'],
    emailConfig: {
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        user: 'kamrujjaman0228@gmail.com',
        pass: 'emcnoguskyfnziax',
        from: 'kamrujjaman0228@gmail.com',
    }
};
